<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="真实姓名" prop="realName">
                <a-input v-model="queryParam.realName" :maxLength="32" :placeholder="$t('请输入')+'真实姓名'" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="审核状态" prop="status">
                <a-select v-model="queryParam.status" placeholder="请选择审核状态" allow-clear>
                  <a-select-option :value="0">待审核</a-select-option>
                  <a-select-option :value="1">已审核</a-select-option>
                  <a-select-option :value="2">审核拒绝</a-select-option>
                  <a-select-option :value="3">已禁用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template>
              <a-col :md="6" :sm="24">
                <a-form-item label="绑定手机号" prop="mobile">
                  <a-input v-model="queryParam.mobile" :maxLength="32" :placeholder="$t('请输入')+'绑定手机号'" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建时间')" prop="createTimeRange">
                  <a-range-picker style="width: 100%"
                     v-model="queryParam.createTimeRange"
                     :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                     format="YYYY-MM-DD HH:mm:ss"
                     :placeholder="['开始时间', '结束时间']"
                     allow-clear
                     @change="onCreateTimeRangeChange"/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="24" :sm="24">
              <span class="table-page-search-submitButtons" :style="{ float: 'right', overflow: 'hidden' }">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" :disabled="multiple" @click="handleAudit" v-hasPermi="['user:paymentbind:audit']">
          <a-icon type="check-circle" />{{$t('批量审核')}}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:paymentbind:remove']">
          <a-icon type="delete" />{{$t('删除')}}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['user:paymentbind:export']">
          <a-icon type="download" />{{$t('导出')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 审核弹窗 -->
      <a-modal
        title="确认审核"
        :visible="auditModalVisible"
        :footer="null"
        @cancel="handleAuditCancel"
      >
        <p>请选择审核操作</p>
        <div style="text-align: right; margin-top: 20px;">
          <a-button type="danger" @click="handleAuditReject">拒绝</a-button>
          <a-button style="margin-left: 8px" @click="handleAuditCancel">取消</a-button>
          <a-button type="primary" style="margin-left: 8px" @click="handleAuditPass">通过</a-button>
        </div>
      </a-modal>
      <!-- 驳回原因弹窗 -->
      <a-modal
        title="审核拒绝"
        :visible="rejectModalVisible"
        :footer="null"
        @cancel="handleRejectCancel"
      >
        <a-form-item label="驳回原因">
          <a-input
            v-model="rejectReason"
            placeholder="请输入驳回原因"
            :maxLength="200"
          />
        </a-form-item>
        <div style="text-align: right; margin-top: 20px;">
          <a-button @click="handleRejectCancel">取消</a-button>
          <a-button type="primary" style="margin-left: 8px" @click="handleConfirmReject">确定</a-button>
        </div>
      </a-modal>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createdAt" slot-scope="text, record">
          {{ parseTime(record.createdAt) }}
        </span>
        <span slot="updatedAt" slot-scope="text, record">
          {{ parseTime(record.updatedAt) }}
        </span>
        <span slot="qrCodeUrl" slot-scope="text, record">
          <img v-if="text" :src="text" style="width: 80px; height: 80px; object-fit: contain;" />
          <span v-else>-</span>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-if="record.status === 0" v-hasPermi="['user:paymentbind:audit']" />
          <a @click="handleAudit(record)" v-if="record.status === 0" v-hasPermi="['user:paymentbind:audit']">
            <a-icon type="check-circle" />{{$t('审核')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['user:paymentbind:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['user:paymentbind:remove']">
            <a-icon type="delete" />{{$t('删除')}}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pagePaymentBind,listPaymentBind, delPaymentBind, auditPaymentBind } from '@/api/user/paymentBind'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { Modal } from 'ant-design-vue'

export default {
  name: 'PaymentBind',
  components: {
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 审核弹窗
      auditModalVisible: false,
      auditIds: [],
      rejectReason: '',
      rejectModalVisible: false,
      // 查询参数
      queryParam: {
        payType: undefined,
        realName: undefined,
        mobile: undefined,
        status: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        createTimeRange: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        
        {
          title: '用户名称',
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '支付类型',
          dataIndex: 'payType',
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            const payTypeMap = { '1': '支付宝', '2': '微信' }
            return payTypeMap[String(text)] || text
          }
        },
        {
          title: '真实姓名',
          dataIndex: 'realName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '绑定手机号',
          dataIndex: 'mobile',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '收款二维码图片',
          dataIndex: 'qrCodeUrl',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'qrCodeUrl' }
        },
        {
          title: '状态',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            const statusMap = { '0': '待审核', '1': '已审核', '2': '审核拒绝', '3': '已禁用' }
            return statusMap[String(text)] || text
          }
        },
        {
          title: '驳回原因',
          dataIndex: 'rejectReason',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createdAt',
          scopedSlots: { customRender: 'createdAt' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '更新时间',
          dataIndex: 'updatedAt',
          scopedSlots: { customRender: 'updatedAt' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询用户支付绑定列表 */
    getList () {
      this.loading = true
     pagePaymentBind(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        payType: undefined,
        realName: undefined,
        mobile: undefined,
        status: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        createTimeRange: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onCreateTimeRangeChange (value, dateString) {
      if (value && value.length === 2) {
        this.queryParam.createBeginTime = dateString[0]
        this.queryParam.createEndTime = dateString[1]
      } else {
        this.queryParam.createBeginTime = undefined
        this.queryParam.createEndTime = undefined
      }
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          return delPaymentBind(that.ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(message,3)
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 审核按钮操作 */
    handleAudit (row) {
      this.auditIds = row ? [row.id] : this.ids
      this.auditModalVisible = true
    },
    /** 审核取消 */
    handleAuditCancel () {
      this.auditModalVisible = false
      this.auditIds = []
    },
    /** 审核通过 */
    handleAuditPass () {
      var that = this
      auditPaymentBind({ ids: this.auditIds, status: 1 })
        .then(() => {
          that.onSelectChange([], [])
          that.getList()
          that.$message.success(that.$t('审核成功'), 3)
        })
      this.auditModalVisible = false
      this.auditIds = []
    },
    /** 审核拒绝 - 打开驳回原因弹窗 */
    handleAuditReject () {
      this.auditModalVisible = false
      this.rejectReason = ''
      this.rejectModalVisible = true
    },
    /** 驳回原因取消 */
    handleRejectCancel () {
      this.rejectModalVisible = false
      this.rejectReason = ''
      this.auditIds = []
    },
    /** 确认驳回 */
    handleConfirmReject () {
      if (!this.rejectReason.trim()) {
        this.$message.error('驳回原因不能为空')
        return
      }
      var that = this
      auditPaymentBind({ ids: this.auditIds, status: 2, rejectReason: this.rejectReason })
        .then(() => {
          that.onSelectChange([], [])
          that.getList()
          that.$message.success(that.$t('审核成功'), 3)
        })
      this.rejectModalVisible = false
      this.rejectReason = ''
      this.auditIds = []
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('user/payment/bind/export',
            that.queryParam
          , `用户支付绑定_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
